import React from 'react';
import { useState, useRef } from 'react';
import IngredientForm from "../../IngredientForm/IngredientForm";
import { useData } from "../../../DataContext/DataProvider"
import "./IngredientElement.css"

function IngredientElement({
    ingredient
}) {    
    const dataContext = useData();
    const containerRef = useRef(null)
    const [isEditing, setIsEditing] = useState(false)

    function handleFreeze(ingredient) {
        if (isNaN(ingredient.Ingredient_Frozen) === true) {
            ingredient.Ingredient_Frozen = new Date();
        }
        else
            ingredient.Ingredient_Frozen = new Date("null");

        dataContext.ingredientsData.changeIngredient(ingredient);
    }

    function cancelReservationHandler() {
        dataContext.ingredientsData.cancelIngredientReservation(ingredient);
    }

    function editIngredientHandler() {
        setIsEditing(true)
    }

    var dateString = "??/??/????";
    if (ingredient.Ingredient_Date.valueOf()) {
        dateString = ingredient.Ingredient_Date.toLocaleDateString("en-UK",
            {
                weekday:"long",
                day: "numeric",
                month: "numeric",
                year: "numeric"
            }
        );
    }

    var frozenDate = "";
    if (isNaN(ingredient.Ingredient_Frozen) === false) {
        frozenDate = ingredient.Ingredient_Frozen.toLocaleDateString("en-UK",
            {
                weekday: "long",
                day: "numeric",
                month: "numeric",
                year: "numeric"
            }
        );
    }

    var quantityString = "??g";
    if (ingredient.Ingredient_Quantity > 0) {
        quantityString = ingredient.Ingredient_Quantity + "g";
    }

    var styleString = "ingredient-element list-element hoverable-element";
    if (frozenDate !== "")
        styleString += " frozen";
    else if ((ingredient.Ingredient_Date.valueOf()) < new Date().valueOf()) {
        styleString += " warning";
    }
    else if ((ingredient.Ingredient_Date.valueOf() - 86400000) < new Date().valueOf()) {
        styleString += " danger";
    }
    
    function deleteIngredientHandler() {
        containerRef.current.style.opacity = "0";
    }

    function transitionEndHandler(e) {
        if (e.propertyName === "opacity")
            dataContext.ingredientsData.deleteIngredient(ingredient)
    }

    return (
        <li className={styleString} onTransitionEnd={transitionEndHandler} ref={containerRef }>
            <div className={"ing-data-container container " + (isEditing ? "hidden" : "visible")} >
                <p>{ingredient.Ingredient_Name}: {quantityString}</p>
                <p className={dateString === "??/??/????" ? "edit-required" : "" }>{frozenDate !== "" ? "Frozen On: " + frozenDate : "Eat By: " + dateString}</p>
                {ingredient.Plan_ID ? <p className="small-text">Reserved for: {ingredient.Recipe_Name} on {ingredient.Plan_Date.toLocaleDateString()}</p> : null}
            </div>
            <div className={"ing-button-container container " + (isEditing ? "hidden" : "visible")}>
                <button className="button" onClick={deleteIngredientHandler} > Delete </button>
                <button className="button" onClick={handleFreeze.bind(this, ingredient)} >  {frozenDate !== "" ? "Unfreeze" : "Freeze"}  </button>
                <button className="button" onClick={editIngredientHandler} > Edit </button>
                {ingredient.Plan_ID ? <button className="button" onClick={cancelReservationHandler} > Cancel Reservation </button> : null}
            </div>
            <div className={"ingredient-form-container container " + (isEditing ? "visible" : "hidden")}>
                <IngredientForm initialIngredient={ingredient} cancelEditing={() => {setIsEditing(false)} } />
            </div>
        </li>
    );
}

export default IngredientElement;